export default {
      id: "logo-gems-market-white-usage",
      viewBox: "0 0 195 80",
      url: __webpack_public_path__ + "icons.svg#logo-gems-market-white",
      toString: function () {
        return this.url;
      }
    }